import React from 'react';
import {ModalIds, useModal} from "../../contexts/ModalContext";
import {useMediaQuery} from "@mui/material";
import {DialogContentStyled, DialogStyled, DialogTitleStyled} from "./modalComponent";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import {HrLine, VerticalDividerStyled, AnchorStyled} from "../styledComponent/styledComponents";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import DownloadListSvg from "../../assets/svgs/downloadListSvg";
import {listOfOffices} from "../../utils/data";

const ViewListOfOfficesModal = () => {
    const {handleClose, modalId, modalOption} = useModal()
    const matches = useMediaQuery('(min-width:200px) and (max-width:600px)');

    return (
        <DialogStyled open={modalId === ModalIds.VIEW_LIST_OF_OFFICES} onClose={handleClose}
                      minWidth={!matches ? "450px" : "330px"} width={490} height={550} minHeight={290}>
            <DialogTitleStyled>
                <Typography whiteSpace={"noWrap"} component={"span"} fontSize={{xs: 14, sm: 16}} color={'#242424'}
                            fontWeight={'bold'}>
                    دفاتر نزدیک به شما:
                </Typography>
                <Stack width={"100%"} direction={"row"} alignItems={"center"} justifyContent={"end"} gap={1}>
                    <AnchorStyled href={modalOption?.pdf} download target="_blank">
                        <DownloadListSvg/>
                        <Typography whiteSpace={"noWrap"} component={"span"} pr={1} fontSize={14} color={'info.main'}
                                    fontWeight={'bold'}>
                            دانلود لیست
                        </Typography>
                    </AnchorStyled>
                    <VerticalDividerStyled/>
                    <IconButton size={"small"} sx={{ml: -1}} color={"fourth"}>
                        <ClearIcon onClick={handleClose}/>
                    </IconButton>
                </Stack>
            </DialogTitleStyled>
            <HrLine/>
            <DialogContentStyled>
                {
                    modalOption?.officesData?.map((office, i) => (
                        <Stack key={i} gap={1}>
                            <Typography component={"p"} fontSize={14}
                                        color={'tertiary.main'}>{office.title}</Typography>
                            <Typography component={"p"} fontSize={14} lineHeight={2} pb={3}
                                        color={'text.main'}>{office.description}</Typography>
                        </Stack>
                    ))
                }
            </DialogContentStyled>
        </DialogStyled>
    );
};

export default ViewListOfOfficesModal;